export default "__VITE_ASSET__BBFjGGqb__"